export const getLokaleRollenEndpoint = "/lokaleRolle/";
